import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { VolunteerSignupMentorStatusEnum } from '@interfaces';
import { VolunteeringAreaService } from '../../../volunteering-area.service';
import { VolunteeringMentorsService } from '../../volunteering-mentors.service';
import { getSetup } from './grid/get-setup';

@Component({
	selector: 'mentors-back-ups-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './back-ups.part.html',
})
export class BackUpsViewPart implements OnInit {

	private readonly util = inject(UtilityService);
	private readonly areaService = inject(VolunteeringAreaService);
	private readonly pageService = inject(VolunteeringMentorsService);
	private readonly dialogService = inject(DialogService);

	public setup = getSetup(this.areaService, this.util, this.dialogService, this.areaService.app);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public backupMentors = computed(() =>
		this.areaService.volunteeringData()?.signUpMentors
			.filter(m => m.volunteerSignupMentorStatus === VolunteerSignupMentorStatusEnum.Backup) ?? []
	);

	ngOnInit() {
		this.areaService.getVolunteeringData();
	}
}